// extracted by mini-css-extract-plugin
export default {"time":"practice-times-overview_time__19NqT","legend":"practice-times-overview_legend__HuKFh","legend-item":"practice-times-overview_legend-item__7XY8f"};